import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/pages/WorthYourAttentionPage.tsx — the "Worth your attention" surface.
//
// A general per-user ATTENTION feed (the thing the flashing nav icon points at).
// Today it carries Ares trade signals; it's structured so more attention types
// slot in below over time (risk alerts from Orion, tax windows, X-Ray findings,
// monitoring), each its own section. The nav icon flashes to pull the user here.
//
// Clicking a trade card hands the SAME idea to Ares in chat (push → pull).
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { AppShell } from "../components/layout/AppShell";
import { TradeSignalFeed } from "../components/chat/TradeSignalFeed";
import { useCommandPaletteStore } from "../stores/commandPaletteStore";
export default function WorthYourAttentionPage() {
    const navigate = useNavigate();
    const setPendingChatPrompt = useCommandPaletteStore((s) => s.setPendingChatPrompt);
    // Hand the chosen idea to Ares in chat — prefilled so the user can review/send.
    const handoff = (prompt) => {
        setPendingChatPrompt(prompt);
        navigate("/");
    };
    return (_jsx(AppShell, { children: _jsxs("div", { className: "max-w-2xl mx-auto px-4 py-8", children: [_jsxs("div", { className: "mb-6", children: [_jsxs("h1", { className: "text-2xl font-bold text-slate-100 flex items-center gap-2", children: [_jsx(Sparkles, { size: 20, className: "text-violet-400" }), " Worth your attention"] }), _jsx("p", { className: "text-sm text-slate-400 mt-1", children: "What Ares and your specialists surfaced for you \u2014 refreshed daily." })] }), _jsx(TradeSignalFeed, { onBuild: handoff })] }) }));
}
